import { Alert, Box, Typography } from "@mui/material";

import { WebhookIntegrationRecord } from "@/shared/domain/integrations";

import styles from "./FoxgloveIntegrationStepper.module.css";

interface IntegrationCompleteContentProps {
  foxgloveIntegration: WebhookIntegrationRecord | null | undefined;
}

export function IntegrationCompleteContent({
  foxgloveIntegration,
}: IntegrationCompleteContentProps) {
  const includeEvents =
    foxgloveIntegration?.webhook_events?.includes("event.created") ?? false;

  return (
    <>
      <Alert severity="success">
        <Typography variant="body2">
          🎉 Your Foxglove integration is now active! Roboto will automatically
          receive notifications when new recordings{" "}
          {includeEvents ? "and device events" : ""} are created in your
          Foxglove account.
        </Typography>
      </Alert>

      <Box className={styles.marginTop2}>
        <Typography variant="body2" className={styles.marginBottom1}>
          <strong>What happens next:</strong>
        </Typography>
        <Box className={styles.marginLeft2}>
          <Typography variant="body2" component="div">
            • New recordings {includeEvents ? " and device events " : ""} in
            Foxglove will trigger webhook notifications
          </Typography>
          <Typography variant="body2" component="div">
            • Roboto will automatically import and process the data
          </Typography>
          <Typography variant="body2" component="div">
            • You can view imported data in your Roboto datasets
          </Typography>
        </Box>
      </Box>
    </>
  );
}
